import { render, staticRenderFns } from "./cv-overflow-menu-item.vue?vue&type=template&id=e0b6eaf6&"
import script from "./cv-overflow-menu-item.vue?vue&type=script&lang=js&"
export * from "./cv-overflow-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports